define(function (require) {
    var logger = require('system.logger').get('system.helper.EventAggregator');

    var EventEmitter = require('system/helper/EventEmitter');

    /**
     * 
     * @param {object} list
     * @param {string} type - type of list (group name or channel...)
     * @param {string} name
     * @returns {undefined}
     */
    function addToList(list, type, name) {
        if (typeof list[type] === 'undefined') {
            list[type] = [];
        }

        if (list[type].indexOf(name) === -1) {
            list[type].push(name);
        }
    }

    /**
     * Remove item from list. If type is not defined, item is removed from all lists
     * 
     * @param {object} list
     * @param {string} name
     * @param {string} type - type of list (group name or channel...)
     * @returns {void}
     */
    function removeFromList(list, name, type) {
        if (type) {
            var removeIndex = list[type].indexOf(name);

            if (removeIndex > -1) {
                list[type].splice(removeIndex, 1);
            }

            return;
        }

        for (var type in list) {
            var removeIndex = list[type].indexOf(name);

            if (removeIndex > -1) {
                list[type].splice(removeIndex, 1);
            }
        }
    }

    var EventAggregator = function (options) {
        this._registrar = {};
        this._groupList = [];
        this._channels = [];
        this._processing = false;

        this._options = {
        }

        if (typeof options === 'object') {
            for (var item in options) {
                this._options[item] = options[item];
            }
        }
    };

    EventAggregator.prototype = {
        get: function (name) {
            name = name || 'default';

            if (name === 'default' && !this._registrar[name]) {
                this.register(name);
            }

            if (!this._registrar[name]) {
                throw new Error('Name "%s" is not registered.', name);
            }

            return this._registrar[name];
        },
        /**
         * Create new observer with a given name
         * 
         * @param {string} name
         * @returns {object} observer
         */
        register: function (name) {
            for (var existingName in this._registrar) {
                if (existingName === name) {
                    throw new Error('Object with name "' + name + '" is already registered');
                }
            }

            var self = this;

            return this._registrar[name] = {
                _event: new EventEmitter,
                _name: name,
                _to: null,
                _aliases: {},
                _group: null,
                _callMethod: function () {
                    var args = Array.prototype.slice.call(arguments),
                            method = args.shift();

                    // if called with group
                    if (this._group !== null) {
                        if (typeof self._groupList[this._group] === 'undefined') {
                            logger.debug('Group "%s" is not defined. Method "%s" with event "%s" was cancelled.', this._group, method, args[0]);
                            return this;
                        }

                        var group = self._groupList[this._group];

                        logger.debug('Calling method "%s" with event "%s" on group "%s"', method, args[0], this._group);

                        for (var index in group) {
                            logger.debug('Processing name "%s"', group[index]);
                            self._registrar[group[index]]._event[method].apply(this._event, args);
                        }

                        this._group = null;

                        return;
                    }

                    this._event[method].apply(this._event, args);
                },
                /**
                 * Return current name
                 * 
                 * @returns {string} name
                 */
                getName: function () {
                    return this._name;
                },
                /*
                 * Set aliases for observers which can be used for sending event to corresponding observer by callin .toAlias() method
                 * 
                 * @param {array} aliases
                 * @returns {object} this
                 */
                setAliases: function (aliases) {
                    this._aliases = aliases;
                    return this;
                },
                /**
                 * 
                 * @param {string} event
                 * @param {function} listener
                 * @param {bool} call event with callback in the last argument or not
                 * @returns {object} this
                 */
                on: function (event, listener, withCallback) {
                    this._callMethod.call(this, 'on', event, listener, withCallback);

                    logger.debug('Event "%s" attached to "%s"', event, this._name);
                    return this;
                },
                /**
                 *  Return registrar by name
                 * 
                 * @param {string} name
                 * @returns {EventEmitter|null} return registrar EventEmitter or null if not found
                 */
                get: function (name) {
                    if (self._registrar[name]) {
                        return self._registrar[name];
                    }

                    return null;
                },
                /**
                 * Send event to concrete observer. Call before "emit" method. After calling is param "to" cleared.
                 * 
                 * @param {string} name
                 * @returns {object} this
                 */
                to: function (name) {
                    this._to = name;

                    return this;
                },
                /**
                 * Send event to concrete observer by using alias name. Call before "emit" method. After calling is param "to" cleared.
                 * 
                 * @param {string} name
                 * @returns {object} this
                 */
                toAlias: function (alias) {
                    this._to = this.getByAlias(alias);
                    logger.error('Using alias "%s" with name "%s".', alias, this._to);


                    return this;
                },
                hasAlias: function (alias) {
                    return (this._aliases[alias]);
                },
                /**
                 * Return observer name by alias.
                 * 
                 * @param {string} name
                 * @returns {string} name observer name
                 */
                getByAlias: function (alias) {

                    if (!this._aliases[alias]) {
                        logger.error('Unable to find alias "%s".', alias);
                        return;
                    }

                    return this._aliases[alias];
                },
                /**
                 * Attach action to particular group. Call before "emit", "on", "off", "removeListener" methods. After calling is group cleared.
                 * 
                 * @param {string} group name
                 * @returns {object} this
                 */
                group: function (group) {
                    this._group = group;

                    return this;
                },
                removeListener: function (event, listener) {
                    this._callMethod.call(this, 'removeListener', event, listener);
                },
                off: function (event) {
                    this._callMethod.call(this, 'off', event);
                },
                /**
                 * Emit events exclude self
                 * 
                 * @returns {Promise}
                 */
                broadcast: function () {
                    return this._emit(Array.prototype.slice.call(arguments), true);
                },
                /**
                 * Emit events
                 * 
                 * @returns {Promise}
                 */
                emit: function () {
                    return this._emit(Array.prototype.slice.call(arguments), false);
                },
                _emit: function (args, excludeSelf) {
                    excludeSelf = excludeSelf || false;

                    var bindObj = {name: this._name}; // bind object to emit function

                    if (this._group !== null) {
                        if (typeof self._groupList[this._group] === 'undefined') {
                            logger.debug('Group "%s" is not defined', this._group);
                            return Promise.resolve();
                        }

                        var group = self._groupList[this._group],
                                tasks = [];

                        self._processing = true;

                        logger.debug('Sending event "%s" to group "%s"', args[0], this._group);

                        for (var index in group) {
                            logger.debug('Sending event "%s" to "%s"', args[0], group[index]);
                            tasks.push(self._registrar[group[index]]._event.bindTo(bindObj).emit.apply(self._registrar[group[index]]._event, args));
                        }

                        this._group = null;

                        return Promise.all(tasks).then(function (result) {
                            self._processing = false;
                            return Array.prototype.concat.apply([], result);
                        });
                    } else if (this._to !== null) {
                        if (typeof self._registrar[this._to] === 'undefined') {
                            logger.debug('Observer name "%s" not registered.', this._to);
                            return Promise.resolve();
                        }

                        self._processing = true;

                        logger.debug('Sending event "%s" to observer name "%s"', args[0], this._to);

                        return self._registrar[this._to]._event.bindTo(bindObj).emit.apply(self._registrar[this._to]._event, args).then(function (result) {
                            self._to = null;
                            self._processing = false;
                            return result;
                        });
                    } else {
                        var calledNames = [],
                                tasks = [];

                        self._processing = true;

                        for (var channel in self._channels) {

                            if (self._channels[channel].indexOf(this._name) !== -1) {
                                var currentChannel = self._channels[channel];

                                for (var i in currentChannel) {

                                    // do not call same name more than once
                                    if (calledNames.indexOf(currentChannel[i]) !== -1) {
                                        continue;
                                    }

                                    // skip emit to self
                                    if (excludeSelf && self._registrar[currentChannel[i]]._event === this._event) {
                                        continue;
                                    }

                                    logger.debug('Sending event "%s" to ' + ((currentChannel[i] === this._name) ? 'self ' : '') + '"%s"', args[0], currentChannel[i]);

                                    tasks.push(self._registrar[currentChannel[i]]._event.bindTo(bindObj).emit.apply(self._registrar[currentChannel[i]]._event, args));

                                    calledNames.push(currentChannel[i]);
                                }
                            }
                        }

                        return Promise.all(tasks).then(function (result) {
                            self._processing = false;
                            var output = [];
                            
                            for(var task in result){
                                for(var event in result[task]){
                                    output.push(result[task][event]);
                                }
                            }
                            
                            return output;
                        });
                    }
                },
                /**
                 * Join to group
                 * 
                 * @param {string} group
                 * @returns {object} this
                 */
                join: function (group) {
                    addToList(self._groupList, group, this._name);
                    logger.debug('"%s" joined to group "%s"', this._name, group);
                    return this;
                },
                /**
                 * Disconnect from group 
                 * 
                 * @param {string} group
                 * @returns {object} this
                 */
                disconnect: function (group) {
                    removeFromList(self._groupList, this._name, group);
                    logger.debug('"%s" disconnected from group "%s"', this._name, group);
                    return this;
                },
                /**
                 * Subscribe to channel to listen events
                 * 
                 * @param {string} channel
                 * @returns {object} this
                 */
                subscribe: function (channel) {
                    addToList(self._channels, channel, this._name);
                    logger.debug('"%s" subscribed to channel "%s"', this._name, channel);
                    return this;
                },
                /**
                 * Unsubscribe from channel
                 * 
                 * @param {string} channel
                 * @returns {object} this
                 */
                unsubscribe: function (channel) {
                    removeFromList(self._channels, this._name, channel);

                    logger.debug('"%s" unsubscribed from channel "%s"', this._name, channel);

                },
                unregister: function () {
                    self.unregister.call(self, this);
                }
            };
        },
        unregister: function (obj) {
            var self = this;

            if (this._processing) {
                logger.debug('Events are in progress, unregistering "%s" is delayed."', obj._name);
                setTimeout(function () {
                    self.unregister(obj);
                }, 1000);
            }

            if (typeof obj._name !== 'undefined' && typeof obj._event !== 'undefined') {
                obj._event.removeAllEvents();
                this._registrar[obj._name] = null;

                removeFromList(this._groupList, obj._name);
                removeFromList(this._channels, obj._name);

                delete this._registrar[obj._name];

                logger.debug('Removing observer with name "%s"', obj._name);
            } else {
                logger.debug('Object is not observer');
            }
        }
    };

    return EventAggregator;
});